// extracted by mini-css-extract-plugin
export default {"container":"SampleLogin_container__RYZnl"};